import React from 'react';

function Presentation() {
  return (
    <div className="container">
      <div className="presentation-card">
        <div className="presentation-content">
          <h1>O M   G A M E S</h1>
          <p>
          
          </p>
        </div>

      </div>
    </div>
  );
}

export default Presentation;